<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-05-27 10:19:09
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-10 17:07:32
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\chaining\components\CallTemplate\index.vue
-->
<template>
    <!-- 调用模板链 -->
    <el-container class="my-programme">
        <!-- 顶部搜索 -->
        <div class="top">
            <div style="color:#333">调用模板</div>
            <div class="search">
                <div class="inputSearch">
                    <el-input v-model="searchForm.searchContent" prefix-icon="el-icon-search" placeholder="请输入要调用的模板名称"
                        size="small" style="width:20%">
                    </el-input>
                    <div style="margin-left:20px">适配病种：</div>
                    <el-select v-model="searchForm.diseaseTypeId" placeholder="请选择适配病种" size="small">
                        <el-option v-for="(item, index) in diseaseArr" :key="index" :label="item.suborderName"
                            :value="item.id"></el-option>
                    </el-select>
                    <el-button size="small" style="margin-left:20px" @click="searchForm = {}">重置</el-button>
                    <el-button type="primary" size="small"
                        style="margin-left:20px;background:#1A7BFC;border-color:#1A7BFC"
                        @click="getSchemePage()">搜索</el-button>
                </div>
            </div>
        </div>
        <el-main class="list-data">
            <div class="text">
                <div style="margin-bottom:20px">调用方案列表</div>
                <el-table id="tableInfo" :data="tableData" style="width: 100%">
                    <el-table-column prop="name" label="方案名称" align="center"></el-table-column>
                    <el-table-column prop="diseaseType" label="主适配病种" align="center"></el-table-column>
                    <el-table-column prop="subDiseaseTypes" label="适配病种" align="center" class-name="subDiseaseTypes"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="available" label="归属" align="center">
                        <template>
                            <span>平台</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="abbreviation" label="最近一次更新时间" align="center"></el-table-column>缺少
                    <el-table-column prop="updateUserName" label="操作人" align="center"></el-table-column>缺少
                    <el-table-column label="操作" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click="viewScheme(scope.row, scope.$index)" type="text"
                                size="small">查看</el-button>
                            <el-button @click="useScheme(scope.row, scope.$index)" type="text"
                                size="small">调用</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="searchForm.current" :page-size="searchForm.size"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-main>
        <!-- 调用弹窗 -->
        <div>
            <SelectScheme ref="selectScheme" />
            <GanttChart ref="ganttChart" />
        </div>
    </el-container>
</template>

<script>
import GanttChart from '../GanttChart/index'
import SelectScheme from '../SelectScheme/index'
import local from '@/utils/local.js'
import { apiGetSchemePage, api_get_disease_type } from '../../api/index'
export default {
    components: {
        SelectScheme,
        GanttChart
    },
    data() {
        return {
            //表头搜索占位
            showDialog: false,
            searchForm: {
                searchContent: '',
                diseaseTypeId: '',
                size: 10,
                current: 1,
            },
            total: 0,//总条数
            tableData: [],
            diseaseArr: [],
        }
    },
    created() {
        this.getSchemePage()
        this.diseaseList()
    },
    methods: {
        /**
         * @description: 获取适配病种列表
         * @param {*}
         * @return {*}
        */
        diseaseList() {
            api_get_disease_type().then(res => {
                this.diseaseArr = res.data
            })
        },
        /**
         * @description:  获取列表数据
         * @param {*}
         * @return {*}
        */
        getSchemePage() {
            this.searchForm.excludeSchemeId = sessionStorage.getItem('SCHEME_ID')
            apiGetSchemePage({ ...this.searchForm }).then(res => {
                this.tableData = res.data.records
                this.total = res.data.total
            })
        },
        /**
         * @description:  查看按钮 甘特图
         * @param {*}
         * @return {*}
        */
        //查看甘特图
        viewScheme(row, index) {

            //local.set('ADDRESS','scheme')
            this.showDialog = true
            this.$refs.ganttChart.useDialog(row.id, 'scheme');
        },
        /**
         * @description:  调用按钮
         * @param {*}
         * @return {*}
        */
        useScheme(row, index) {
            this.$refs.selectScheme.useDialog(row, index)
        },
        /**
         * @description:  分页触发事件
         * @param {*}
         * @return {*}
        */
        handleSizeChange(val) {
            this.searchForm.size = val
            this.getSchemePage()
        },
        handleCurrentChange(val) {
            this.searchForm.current = val
            this.getSchemePage()
        },
    },
}
</script>
<style lang="less" scoped>
.my-programme {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .top {
        height: 130px;
        width: 100%;
        background: #fff;
        padding: 0px 25px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .search {
            margin-top: 30px;
            display: flex;
            align-items: center;

            .icon {
                display: flex;

                div {
                    height: 36px;
                    width: 36px;
                    border-radius: 50%;
                    background: #F0F0F0;
                    color: #1A7BFC;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 15px;
                    font-size: 16px;
                    cursor: pointer;

                    &.active {
                        color: #fff;
                        background: #1A7BFC;
                    }
                }
            }

            .inputSearch {
                flex: 1;
                display: flex;
                align-items: center;
            }
        }
    }

    .list-data {
        width: 100%;
        padding: 25px 25px;
        padding-top: 15px;

        .text {
            width: 100%;
            background: #fff;
            border-radius: 5px;
            padding: 25px;
        }
    }
}

/deep/.el-scrollbar__wrap {
    overflow-x: hidden;
}

/deep/.el-pagination {
    text-align: right;
    margin-top: 30px;
    margin-right: 30px;
}

/deep/.el-table__header-wrapper {
    background-color: #FAFAFA;
}

/deep/.el-table th>.cell {
    color: #333;
    font-weight: bold;
}

/deep/.el-table th {
    background: #FAFAFA;
}
</style>
